import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=f81b12d0&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=f81b12d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81b12d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81b12d0')) {
      api.createRecord('f81b12d0', component.options)
    } else {
      api.reload('f81b12d0', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=f81b12d0&scoped=true", function () {
      api.rerender('f81b12d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/blend/sidebar/Logo.vue"
export default component.exports